import { NewsCard } from "@/components/News/NewsCard";
import { ResponsiveContainer } from "@/components/common/ResponsiveContainer";
import { News } from "@/models/types";
import { useTranslation } from "next-i18next";
import Link from "next/link";

interface NewsListProps {
  news: News[];
  title: string;
  type: "pokal" | "bundesliga";
}
export function NewsList({ news, title, type }: NewsListProps) {
  const { t } = useTranslation();
  return (
    <ResponsiveContainer widthLeft={100}>
      <div title={title}>
        <div>
          <div className="lg:grid lg:grid-cols-4 gap-4 bg-transparent">
            {news.map((n) => (
              <NewsCard news={n} key={n.id} />
            ))}
          </div>
          <div className="text-center mt-5 md:mt-10 mb-5">
            <Link className="btn" href={`/news/${type}/1`}>
              {t("Show_All_News")}
            </Link>
          </div>
        </div>
      </div>
    </ResponsiveContainer>
  );
}
